var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomesPowered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.28 54.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4edfe;\n      }\n\n      .cls-2 {\n        fill: #823df5;\n      }\n\n      .cls-3 {\n        fill: #c6aafc;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.14,
    cy: 27.39,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.14,50.89c-12.96,0-23.5-10.54-23.5-23.5S16.18,3.89,29.14,3.89s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5ZM29.14,5.39c-12.13,0-22,9.87-22,22s9.87,22,22,22,22-9.87,22-22S41.27,5.39,29.14,5.39Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_25694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    className: "cls-2",
    d: "M29.14,21.29l-9.17,7.56s0,.03,0,.05c0,.02,0,.03,0,.05v7.66c0,.56.46,1.01,1.02,1.02h6.12v-6.12h4.08v6.12h6.12c.56,0,1.01-.46,1.02-1.02v-7.65s0-.07-.02-.1l-9.17-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    className: "cls-2",
    d: "M41.82,27.13l-3.49-2.9v-6.51c.01-.27-.2-.5-.47-.51-.01,0-.02,0-.04,0h-3.06c-.27-.01-.5.2-.51.47,0,.01,0,.03,0,.04v3.11l-3.89-3.25c-.71-.55-1.71-.55-2.42,0l-11.47,9.55c-.11.08-.17.21-.18.34-.01.13.03.27.11.38l.99,1.18c.09.1.21.16.34.18.14,0,.27-.03.38-.11l11.04-9.2,11.04,9.2c.09.08.21.12.33.11h.05c.13-.02.25-.08.33-.17l.99-1.18c.08-.11.12-.24.11-.38,0-.13-.07-.26-.17-.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomesPowered);
export default __webpack_public_path__ + "static/media/Homes Powered.cdbb98e9da3b5d4ca07a80e6e2f740ae.svg";
export { ForwardRef as ReactComponent };